// extracted by mini-css-extract-plugin
export default {"heading":"SearchHeading_heading__Frsux"};